/** Overrides Select `min-w-[15rem]` so the trigger and list stay compact. */
export const PAGINATION_SELECT_CLASSNAME = 'w-max min-w-0 shrink-0'
